export const WIDGET_NAME = 'document_upload';
export const SELECTORS = {
    BACK_BUTTON: `[data-id=back-button]`,
    DONE_BUTTON: `[data-id=done-button]`,
    UPLOAD_BTN: `.upload_btn`,
    UPLOAD_INPUT: `.upload_input`,
};
export const EVENTS = {
    [`tap ${SELECTORS.BACK_BUTTON}`]: 'onBackClick',
    [`tap ${SELECTORS.DONE_BUTTON}`]: 'onDoneClick',
    [`tap ${SELECTORS.UPLOAD_BTN}`]: 'onUploadButtonCLicked',
    [`change ${SELECTORS.UPLOAD_INPUT}`]: 'onFileUpload',
};
export const CATEGORIES = [
    'ID', 'MP', 'VD', 'BT', 'AR', 'OT',
];
export const STATES = {
    default: 'DEFAULT',
    success: 'SUCCESS',
    warning: 'WARNING',
    failed: 'FAILED',
};
